package net.frozenbit.games.soundgame.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import net.frozenbit.games.soundgame.theme.Typography
import net.frozenbit.games.soundgame.viewmodels.presentation.PlayerTagData
import org.jetbrains.compose.resources.painterResource
import soundgame.app.shared.generated.resources.Res
import soundgame.app.shared.generated.resources.*

@Composable
fun PlayerTag(
    player: PlayerTagData,
    modifier: Modifier = Modifier,
) {
    PlayerTag(
        modifier = modifier,
        name = player.name,
        avatarIndex = player.avatarIndex,
        offline = player.isOffline,
    )
}

@Composable
fun PlayerTag(
    modifier: Modifier = Modifier,
    name: String,
    avatarIndex: Int,
    offline: Boolean,
) {
    Row(
        modifier = modifier
            .background(Color.White, RoundedCornerShape(8.dp))
            .padding(8.dp)
            .alpha(if (offline) 0.5f else 1f),
        horizontalArrangement = Arrangement.spacedBy(8.dp),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Image(
            painter = painterResource(avatars[avatarIndex % avatars.size]),
            contentDescription = null,
            modifier = Modifier.size(64.dp),
        )
        Text(
            text = name,
            fontSize = Typography.Host.bodySize,
            fontFamily = Typography.fingerPaint(),
        )
    }
}

val avatars = listOf(
    Res.drawable.avatar_00,
    Res.drawable.avatar_01,
    Res.drawable.avatar_02,
    Res.drawable.avatar_03,
    Res.drawable.avatar_04,
    Res.drawable.avatar_05,
    Res.drawable.avatar_06,
    Res.drawable.avatar_07,
    Res.drawable.avatar_08,
    Res.drawable.avatar_09,
    Res.drawable.avatar_10,
    Res.drawable.avatar_11,
    Res.drawable.avatar_12,
    Res.drawable.avatar_13,
    Res.drawable.avatar_14,
    Res.drawable.avatar_15,
    Res.drawable.avatar_16,
    Res.drawable.avatar_17,
    Res.drawable.avatar_18,
    Res.drawable.avatar_19,
    Res.drawable.avatar_20,
    Res.drawable.avatar_21,
    Res.drawable.avatar_22,
    Res.drawable.avatar_23,
    Res.drawable.avatar_24,
)

@Composable
@Preview
private fun PlayerTagPreview() {
    Row {
        PlayerTag(
            name = "Player 1",
            avatarIndex = 0,
            offline = false,
        )
        PlayerTag(
            name = "Player 2",
            avatarIndex = 1,
            offline = true,
        )
    }
}